"use strict";
var Guide = {
  centerId: '',
  selectedCategory: '',
  partners: null,

  init: function (category, centerId) {

    $('.category').click(function(event) {

      if (Guide.selectedCategory !== event.target.id) {
          Guide.selectedCategory = event.target.id;
          Guide.selectCategory(event.target.id);
      }

      if (Guide.detectIfMobileLayout()) {
        Guide.collapseCategories();
      }

      MMap.showSelectedCategoryMarkers($(event.target).data('typename'));

    });

    Guide.centerId = centerId;

    $('.js-guide-menu-toggle').click(Guide.toggleGuideMenu);
    $('.js-reset-category-selection').click(Guide.resetCategorySelection);

    $('#resultsContainer').on("scroll",function(){
      $("body").trigger("forceLazyLoad");
    });

  },

  detectIfMobileLayout: function() {
    return $(".js-navbar-toggler").is(":visible");
  },

  selectCategory: function (categoryType) {
    var categoryElement = $('#'+categoryType);
    var defaultCategory = categoryType == '' || categoryType == 'all';
    $('.category-title')
      .toggleClass('hidden', defaultCategory)
      .find('h1').text(categoryElement.text());
    $('.category-description')
      .toggleClass('hidden', defaultCategory)
      .find('p').text(categoryElement.data('description'));

    if (categoryType == '') return;

    $('.currently-selected-category').text(categoryElement.text());

    $(".category").each(function () {
      $(this).toggleClass("selected", this.id == categoryType);
    });

    Guide.filterPartners(categoryType, MMap.currentFloor);

    var split = window.location.pathname.split('/');
    var guideCategorySlug = categoryElement.data('slug');
    var url = '/' + split[1] + '/' + split[2] + '/'+ split[3] + '/' + (guideCategorySlug ? guideCategorySlug + '/'  : '');
    history.replaceState({}, null, url);
    $("body").trigger("forceLazyLoad");
    if (categoryElement) {

      if (Guide.detectIfMobileLayout()) {
        Guide.expandGuideMenuWithoutCategories();
      } else {
        Guide.expandGuideMenu();
      }

    }

  },

  filterPartners: function(selectedCategory, selectedFloor) {

    if (Guide.partners == null) {
        var query = {
            source: "guide",
            query: null,
            index: "partners",
            numericFilters: ["centerIds=" + Guide.centerId],
            hitsPerPage: 100
        };

        Guide.guideSearch(query, function(content) {
          Guide.partners = content;
          var indexResult = content.hits.map(function(o) {return o.slug});
          Guide._partnerSearch('', indexResult,selectedCategory, selectedFloor);
        });
    }
    else
    {
      var indexResult = Guide.partners.hits.map(function(o) {return o.slug});
      Guide._partnerSearch('', indexResult,selectedCategory, selectedFloor);
    }
  },

    guideSearch: function(query, callback) {
        var ajaxCall = new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                url: '/searchproxy2/',
                data: JSON.stringify(query),
                datatype: 'json',
                contentType: 'application/json',
                complete: function (results, textStatus, jqXHR) {
                    //console.log(results);
                    resolve(results);
                }
            });
        });
        return ajaxCall.then(function(response) {
            if (response) {
                callback(response);
            }
        });
    },


  _partnerSearch: function(searchValue, indexResult,selectedCategory, selectedFloor){

    var noFloorsConfigured = selectedFloor == 'null';
    var noResultsForCurrentFloor = true;
    $('.js-partner-item').each(function (i, el) {
      var partner = $(el);
      var partnerName = partner.find(".card-title").text();
      var partnerSlug = partner.find(".card-title").data("slug");
      var matchesCurrentFloor = partner.data('floor') == selectedFloor;
      var floorMatches =  (selectedCategory != 'all' || matchesCurrentFloor) || selectedCategory == 'all';
      var categoryMatches = selectedCategory == 'all' || partner.data('category') == selectedCategory;
      var searchMatches = searchValue == '' || partnerName.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0;
      var slugMatches = indexResult.indexOf(partnerSlug) >= 0;
      if (matchesCurrentFloor && ((partner.data('category') == selectedCategory) || selectedCategory == 'all')) {
        noResultsForCurrentFloor = false;
        partner.addClass('on-current-floor');
      } else {
        partner.removeClass('on-current-floor');
      }
      partner.toggle(categoryMatches && (searchMatches || slugMatches) && (floorMatches || noFloorsConfigured));
    });

    $("body").trigger("forceLazyLoad");

    if(noResultsForCurrentFloor && !noFloorsConfigured) {

      $("#noResultsForThisFloorMessage").show();

    } else {

      $("#noResultsForThisFloorMessage").hide();

    }
  },

  expandGuideMenu: function () {
    $('.guide-menu-toggler').removeClass('collapsed');
    $('#resultsContainer').addClass('show');
    $('#categoriesContainer').addClass('show');
    $("body").trigger("forceLazyLoad");
  },

  expandGuideMenuWithoutCategories: function () {
    $('.guide-menu-toggler').removeClass('collapsed');
    $('#resultsContainer').addClass('show');
    $('#categoriesContainer').removeClass('show');
    $("body").trigger("forceLazyLoad");
  },

  collapseGuideMenu: function () {
    $('.guide-menu-toggler').addClass('collapsed');
    $('#resultsContainer').removeClass('show');
    $('#categoriesContainer').removeClass('show');
  },

  collapseCategories: function () {
    $('#categoriesContainer').removeClass('show');
  },

  resetCategorySelection: function () {
    Guide.selectCategory('all');
    $('#resultsContainer').removeClass('show');
    $('#categoriesContainer').addClass('show');
    $("body").trigger("forceLazyLoad");
  },

  toggleGuideMenu: function () {
    var guideMenuCollapsed = $('.js-guide-menu-toggle').hasClass('collapsed');
    if (guideMenuCollapsed) {
      Guide.expandGuideMenu()
      $("body").trigger("forceLazyLoad");
    } else {
      Guide.collapseGuideMenu();
    }
  }

};
